// extracted by mini-css-extract-plugin
export var cardTitle = "_jd-1";
export var commentBubble = "_jd-e";
export var commentForm = "_jd-a";
export var commentInput = "_jd-b";
export var commentLabel = "_jd-d";
export var commentPrompt = "_jd-9";
export var csatCard = "_jd-0";
export var feedbackSection = "_jd-7";
export var starDisabled = "_jd-6";
export var starEmpty = "_jd-5";
export var starFilled = "_jd-4";
export var starWrapper = "_jd-3";
export var starsContainer = "_jd-2";
export var submittedComment = "_jd-c";
export var thankYouText = "_jd-8";